import Box from '../atoms/Box';
import InfoCircle from '../atoms/icons/InfoCircle';
import Text from '../atoms/Text';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { variant } from 'styled-system';

const Message = styled(Box)(
  ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    fontSize: '12px',
    padding: '4px 14px 4px 8px',
    border: '1px dashed',
    borderColor: theme.colors.greyer,
    borderRadius: '16px',
    'svg.icon': {
      paddingLeft: 1,
      color: theme.colors.greyDark,
      width: '20px',
      height: 'auto'
    }
  }),
  () =>
    variant({
      variants: {
        default: {
          '.text': {
            paddingLeft: '8px'
          }
        },
        larger: {
          padding: '12px',
          fontSize: '14px',
          fontWeight: 500,
          alignItems: 'flex-start',
          'svg.icon': {
            marginTop: '5px',
            width: '40px'
          }
        }
      }
    })
);

/**
 * @param {string} text
 * @param {string} hoverText
 * @param {'default' | 'larger'} variant
 * @returns {JSX.Element}
 * @constructor
 */
const MandatorySkillMessageMessage = ({ text, hoverText, variant = 'default' }) => (
  <Box pt={1} className="tooltip" data-text={hoverText}>
    <Message variant={variant}>
      <InfoCircle className="icon" />
      <Text className="text">{text}</Text>
    </Message>
  </Box>
);

MandatorySkillMessageMessage.defaultProps = {
  variant: 'default'
};

MandatorySkillMessageMessage.propTypes = {
  text: PropTypes.string,
  hoverText: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'larger'])
};

export default MandatorySkillMessageMessage;
